export default __webpack_public_path__ + "f8c852cf7136a31114458c50d376514c.png";